import {NgModule} from '@angular/core';

import {CurrentZoneIndicatorComponent} from './current-zone-indicator.component';
import {DevExtremeModule} from "../devextreme.module";
import { CommonModule } from '@angular/common';
import {ZoneIndicatorApiService, ZoneIndicatorApiServiceImpl} from "./model/model";
import {ZoneLevelsPopoverComponent} from "./popover/zone-levels-popover.component";
import {CurrentZoneService, CurrentZoneServiceImpl} from "./model/current-zone.service";
import {CashFlowPortfoliosService} from "../adjustment-pricing-grid/services/cashflow-portfolios.service";
import {GenericConfirmationDialogModule} from "../generic-confirmation-dialog/generic-confirmation-dialog.module";
import {GenericInputDialogModule} from "../generic-input-dialog/generic-input-dialog.module";
import {ZoneLevelsPopover2Component} from "./popover2/zone-levels-popover-2.component";

@NgModule({
    imports: [
        CommonModule,
        DevExtremeModule,
        GenericConfirmationDialogModule,
        GenericInputDialogModule,
    ],
    exports: [
        CurrentZoneIndicatorComponent,
        ZoneLevelsPopover2Component
    ],
    declarations: [
        CurrentZoneIndicatorComponent,
        ZoneLevelsPopoverComponent,
        ZoneLevelsPopover2Component
    ],
    providers: [
        CashFlowPortfoliosService,
        { provide: ZoneIndicatorApiService, useClass: ZoneIndicatorApiServiceImpl },
        { provide: CurrentZoneService, useClass: CurrentZoneServiceImpl  },
    ],
})
export class CurrentZoneIndicatorModule {
}
